import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TopUpCardComponent } from '../../widgets/top-up-card/top-up-card.component';

export interface CheckAccountBalanceModalData {
  plan?: any;
}

@Component({
  selector: 'app-check-account-balance-modal',
  imports: [CommonModule, TranslateModule, TopUpCardComponent],
  templateUrl: './check-account-balance-modal.component.html',
  styleUrl: './check-account-balance-modal.component.scss'
})
export class CheckAccountBalanceModalComponent implements OnInit, OnDestroy {
  public showTopUpCard = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CheckAccountBalanceModalData,
    private dialogRef: MatDialogRef<CheckAccountBalanceModalComponent>,

  ) { }

  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(result?: 'topup' | 'enough-balance'): void {
    this.beforeClose();
    this.dialogRef.close(result);
  }

  topUpBalance(): void {
    this.showTopUpCard = true;
  }

  gotEnoughBalance(): void {
    this.closeDialog('enough-balance');
  }
}
